import React from "react";
import styled from "styled-components";
//import HeroBackgroundImage from "../../../assets/images/Homepage/HeroSection/background.svg";
import HeroBackgroundVideo from "../../../assets/images/Homepage/HeroSection/hero-background.mp4";
import HeyBOAiSvg from "../../../assets/images/Homepage/HeroSection/heybo-ai.svg";
import { Tooltip } from "antd";
import ButtonSM from "../../common/buttons/buttonSM";

/* #region SCOPED CSS */
const StyledPage = styled.div`
    &.frame-1000011137,
    &.frame-1000011137 * {
        box-sizing: border-box;
    }
    &.frame-1000011137 {
        background: #050505;
        height: 279px;
        position: relative;
        overflow: hidden;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        gap: 20px;
    }
    .group-1000011150 {
        height: auto;
        position: absolute;
        overflow: visible;
        width: 100%;
        video {
            width: 100%;
            height: auto;
            filter: blur(10px); /* Add blur effect */
        }
        &::after {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.4); /* 40% black transparency */
            pointer-events: none;
        }
    }
    .group-1000011156 {
        position: absolute;
        inset: 0;
    }
    .ellipse-158 {
        background: #050505;
        border-radius: 50%;
        width: 696px;
        height: 206px;
        position: absolute;
        filter: blur(60px);
    }
    .ellipse-159 {
        background: #050505;
        border-radius: 50%;
        width: 696px;
        height: 206px;
        position: absolute;
        filter: blur(60px);
    }
    .frame-1000011152 {
        display: flex;
        flex-direction: column;
        gap: 20px;
        align-items: center;
        justify-content: flex-start;
        /* position: absolute;
        left: calc(50% - 195px);
        top: 121px; */
    }
    .welcome-to-hey-bo {
        color: #ffffff;
        text-align: center;
        font-family: "ITC Avant Garde Gothic";
        font-size: 40px;
        font-weight: 500;
        position: relative;
        align-self: stretch;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .the-ai-connecting-you-to-local-stores-in-real-time {
        color: #ffffff;
        text-align: center;
        font-family: "ITC Avant Garde Gothic";
        font-size: var(--subtitle-1-font-size, 16px);
        line-height: var(--subtitle-1-line-height, 24px);
        font-weight: var(--subtitle-1-font-weight, 400);
        position: relative;
        align-self: stretch;
    }
    .frame-313708 {
        display: flex;
        flex-direction: row;
        gap: 16px;
        align-items: center;
        justify-content: center;
        width: 100%;
    }

    .frame-29591 {
        display: flex;
        flex-direction: row;
        gap: 5.56px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 85.68px;
        height: 27px;
        position: relative;
    }
    @media (max-width: 768px) {
        &.frame-1000011137 {
            height: 169px;
            gap: 10px;
        }
        .frame-1000011152 {
            gap: 10px;
        }
        .welcome-to-hey-bo {
            font-size: 30px;
        }
        .the-ai-connecting-you-to-local-stores-in-real-time {
            font-size: 12px;
        }
        .ellipse-158,
        .ellipse-159 {
            width: 292px;
            height: 114px;
        }
    }
`;
/* #endregion */

export default function HeroSection({ title, description, buttonTitle, buttonOnClick }) {
    return (
        <StyledPage className="frame-1000011137">
            <div className="group-1000011150">
                <video autoPlay loop muted>
                    <source src={HeroBackgroundVideo} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
            </div>
            <div className="ellipse-158"></div>
            <div className="ellipse-159"></div>
            <div className="frame-1000011152">
                <div className="welcome-to-hey-bo">{title}</div>
                <div className="the-ai-connecting-you-to-local-stores-in-real-time">{description}</div>
            </div>
            <div className="frame-313708">
                <Tooltip placement="bottom" title={""} color="#212121" overlayClassName="custom-tool-tip">
                    <div>
                        <ButtonSM
                            title={buttonTitle}
                            icon={HeyBOAiSvg}
                            borderColor="#7745e0"
                            useHeyBOBorderAnimation={true}
                            style={{ width: "143.68px" }}
                            onClick={buttonOnClick}
                        />
                    </div>
                </Tooltip>
            </div>
        </StyledPage>
    );
}
